import "./ampBannerCss.scss"
import { Grid, Typography, Box, Card, CardContent } from "@mui/material";

/* COBALT FILES */
import cobaltBackground from "../../../static/images/TSDD/amplifiers/cobalt.webp"
import cobaltKnobs from "../../../static/images/TSDD/amplifiers/cobalt_knobs.webp"
import cobaltMode from "../../../static/images/TSDD/amplifiers/cobalt_mode.webp"
import cobaltOverkill from "../../../static/images/TSDD/amplifiers/cobalt_overkill.webp"
import cobaltTubes from "../../../static/images/TSDD/amplifiers/cobalt_tubes.webp"
import cobaltPlugin from "../../../static/images/TSDD/plugin.webp"

// AUDIO
import cobaltMain from "../../../static/audio/TSDD/Cobalt/cobalt_main.mp3"

import cobaltRedRhythm from "../../../static/audio/TSDD/Cobalt/cobalt_demo_rhythm_red.mp3"
import cobaltBlueRhythm from "../../../static/audio/TSDD/Cobalt/cobalt_demo_rhythm_blue.mp3"


import cobaltOverkillOn from "../../../static/audio/TSDD/Cobalt/cobalt_overkill_on.mp3"
import cobaltOverkillOff from "../../../static/audio/TSDD/Cobalt/cobalt_overkill_off.mp3"

import cobalt6L6 from "../../../static/audio/TSDD/Cobalt/cobalt_6l6.mp3"
import cobaltEL34 from "../../../static/audio/TSDD/Cobalt/cobalt_el34.mp3"


/* HAMMERFAUST FILES */
import hammerfaustBackground from "../../../static/images/TSDD/amplifiers/hammerfaust.webp"
import hammerfaustPlugin from "../../../static/images/TSDD/amplifiers/hammerfaust_plugin.webp"
import hammerfaustKnobs from "../../../static/images/TSDD/amplifiers/hammerfaust_knobs.webp"
import hammerfaustScoop from "../../../static/images/TSDD/amplifiers/hammerfaust_scoop.webp"
import hammerfaustOverkill from "../../../static/images/TSDD/amplifiers/hammerfaust_overkill.webp"

// AUDIO
import hammerfaustMain from "../../../static/audio/TSDD/Hammerfaust/hammerfaust_main.mp3"

import hammerfaustScoopOff from "../../../static/audio/TSDD/Hammerfaust/hammerfaust_scoop_off.mp3"
import hammerfaustScoopHalf from "../../../static/audio/TSDD/Hammerfaust/hammerfaust_scoop_half.mp3"
import hammerfaustScoopFull from "../../../static/audio/TSDD/Hammerfaust/hammerfaust_scoop_full.mp3"

import hammerfaustOverkillOff from "../../../static/audio/TSDD/Hammerfaust/hammerfaust_no_overkill.mp3"
import hammerfaustOverkillOn from "../../../static/audio/TSDD/Hammerfaust/hammerfaust_yes_overkill.mp3"

/* ICONA FILES */
import iconaBackground from "../../../static/images/TSDD/amplifiers/icona.webp"
import iconaPlugin from "../../../static/images/TSDD/amplifiers/icona_plugin.webp"
import iconaKnobs from "../../../static/images/TSDD/amplifiers/icona_knobs.webp"
import iconaOverkill from "../../../static/images/TSDD/amplifiers/icona_overkill.webp"
import iconaClipper from "../../../static/images/TSDD/amplifiers/icona_clipper.webp"
import iconaVoice from "../../../static/images/TSDD/amplifiers/icona_voice.webp"

import iconaMain from "../../../static/audio/TSDD/Icona/icona_main.mp3"

import iconaOverkillOn from "../../../static/audio/TSDD/Icona/icona_overkill.mp3"
import iconaOverkillOff from "../../../static/audio/TSDD/Icona/icona_no_overkill.mp3"

import iconaClipperNone from "../../../static/audio/TSDD/Icona/icona_clipper_none.mp3"
import iconaClipperZener from "../../../static/audio/TSDD/Icona/icona_clipper_zener.mp3"
import iconaClipperTransistor from "../../../static/audio/TSDD/Icona/icona_clipper_transistor.mp3"

import iconaVoiceNeutral from "../../../static/audio/TSDD/Icona/icona_voice_neutral.mp3"
import iconaVoiceDeep from "../../../static/audio/TSDD/Icona/icona_voice_deep.mp3"
import iconaVoiceModern from "../../../static/audio/TSDD/Icona/icona_voice_modern.mp3"

// AUDIO

/* NASSAU FILES */
import nassauBackground from "../../../static/images/TSDD/amplifiers/nassau.webp"
import nassauPlugin from "../../../static/images/TSDD/amplifiers/nassau_plugin.webp"
import nassauKnobs from "../../../static/images/TSDD/amplifiers/nassau_knobs.webp"
import nassauSwitches from "../../../static/images/TSDD/amplifiers/nassau_switches.webp"
import nassauTremolo from "../../../static/images/TSDD/amplifiers/nassau_tremolo.webp"

import nassauMain from "../../../static/audio/TSDD/Nassau/nassau_main.mp3"

import nassauNeutral from "../../../static/audio/TSDD/Nassau/nassau_neutral_switches.mp3"
import nassauBright from "../../../static/audio/TSDD/Nassau/nassau_bright_switches.mp3"
import nassauEra from "../../../static/audio/TSDD/Nassau/nassau_era_switches.mp3"
import nassauDeep from "../../../static/audio/TSDD/Nassau/nassau_deep_switches.mp3"

import nassauTremoloOff from "../../../static/audio/TSDD/Nassau/nassau_tremolo_off.mp3"
import nassauTremoloMild from "../../../static/audio/TSDD/Nassau/nassau_tremolo_mild.mp3"
import nassauTremoloIntense from "../../../static/audio/TSDD/Nassau/nassau_tremolo_intense.mp3"

// AUDIO

import ImageTextSection from "../../Utilities/ImageTextSection";
import { FullPagePage, FullPagePager } from "../../Utilities/FullScreenWrapper";

const TEXT_COLOR = "#000";
const ALT_TEXT_COLOR = "#000";


// Cobalt — Design Story content
const cobaltDesignStory = {
  heroKicker: "Cobalt Design Story",
  heroTitle: "Modern, tight, and unapologetically aggressive.",
  heroBody:
    "Designed to be Dave's workhorse amplifier. Cobalt delivers surgical tightness, massive gain, and switchable 6L6 and El34 power tubes with Blue and Red modes that let you toggle the aggression exactly as needed.",
  sections: [
    {
      title: "Modern Metal",
      body:
        "Cobalt’s gain structure is tuned for precision: fast low-end for percussive chugs, a present midrange for definition, and highs that stay smooth under extreme saturation.",
      image: cobaltKnobs,
      alt: "Close-up of the Cobalt gain and EQ section",
      align: "left",
      audioSrc: cobaltMain,
      audioLabel: "Cobalt - Diabolical Majesty (Revocation)",
    },
    {
      title: "Aggression Mode",
      image: cobaltMode,
      body:
        "Flip between two distinct characters on demand. Blue mode focuses tames the higher mids slightly, for a rounder tone. Red mode adds bite and saturation, opening up the sound for modern, low tuned riffs.",
      alt: "Cobalt front panel showing Blue/Red mode switch",
      align: "right",

      audios: [
        { src: cobaltBlueRhythm, label: "Blue Mode — Rhythm demo" },
        { src: cobaltRedRhythm, label: "Red Mode — Rhythm demo" },
      ]
    },
    {
      title: "Overkill: When Too Much Is Not Enough.",
      body:
        "Is the default gain staging not enough? Do you need that extra bit of edge for your lead tone? Overkill delivers. This switch adds more of everything. More gain, more aggression. All while keeping the tight nature of the amp intact.",
      image: cobaltOverkill,
      alt: "Cobalt Overkill Switch",
      align: "left",

      audios: [
        { src: cobaltOverkillOn, label: "Overkill On — Lead demo" },
        { src: cobaltOverkillOff, label: "Overkill Off — Lead demo" },
      ]
    },
    {
      title: "Switchable Power Tubes. Switchable Feel.",
      body:
        "Can't decide wether you like 6L6 or EL34 tubes better? Why not have both. With the flick of a switch, toggle between a 6L6 power section for HiFi like clarity, or an EL34 power section for a smoother sound.",
      image: cobaltTubes,
      alt: "Power tubes on the Cobalt",
      align: "right",
      audios: [
        { src: cobalt6L6, label: "6L6 Mode — Rhythm demo" },
        { src: cobaltEL34, label: "EL34 Mode — Rhythm demo" },
      ]
    },

  ],
  principles: [
    "ToneSuite - Dave Davidson",
    "Tight Low End",
    "Aggression",
    "Extreme High Gain"
  ],
  features: [
    { label: "Preamp Tubes", caption: "5x 12AX7" },
    { label: "Power Amp Tubes", caption: "2x 6L6, 2x EL34" },
    { label: "Power Amp Class", caption: "Class A/B" },
    { label: "Rectifier Type", caption: "Silicon Diodes" },
    { label: "Channel Configuration", caption: "Single Channel" },
    { label: "Special Features", caption: "Aggression Mode, Overkill, Tube Selector" },
  ]
};

const hammerfaustDesignStory = {
  heroKicker: "Hammerfaust Design Story",
  heroTitle: "Dark, gritty, full of power.",
  heroBody:
    "Designed to fill the gap between modern tightness and oldschool thickness. ",
  sections: [
    {
      title: "A German Powerhouse",
      body:
        "The Hammerfaust is designed to add that very specific German high gain flavour to your collection. Don't get fooled by its dark nature though, it clears up quickly with some boosted presence and treble. Shape your mids with the added mid scoop control and add some clank with the overkill mode, this amp has hours of toneshaping possibilities in it.",
      image: hammerfaustKnobs,
      alt: "Close-up of the Hammerfaust gain and EQ section",
      align: "left",
      audioSrc: hammerfaustMain,
      audioLabel: "Hammerfaust - Diabolical Majesty (Revocation)",
    },
    {
      title: "Scoop Those Mids",
      image: hammerfaustScoop,
      body:
        "Prevent your low mids from taking over with this added scoop control. It quickly lets you cut around key frequencies that your standard tonestack can't quite reach.",
      alt: "Hammerfaust front panel showing mid scoop control",
      align: "right",
      audios: [
        { src: hammerfaustScoopOff, label: "Scoop Off — Rhythm demo" },
        { src: hammerfaustScoopHalf, label: "Scoop Half — Rhythm demo" },
        { src: hammerfaustScoopFull, label: "Scoop Full — Rhythm demo" },
      ]
    },
    {
      title: "Add That Clank",
      body:
        "The overkill on this amp adds another gainstage in front of it. This stage is carefully crafted to add hefty boost to the upper mids, resulting in a modern clanky sound that works well on low tuned guitars.",
      image: hammerfaustOverkill,
      alt: "Hammerfaust Overkill Switch",
      align: "left",
      audios: [
        { src: hammerfaustOverkillOff, label: "Overkill Off — Rhythm demo" },
        { src: hammerfaustOverkillOn, label: "Overkill On — Rhythm demo" },
      ]
    },

  ],
  principles: [
    "ToneSuite - Dave Davidson",
    "Massive Low End",
    "Dark",
    "Perfectly Scoopable"
  ],

  features: [
    { label: "Preamp Tubes", caption: "4x 12AX7" },
    { label: "Power Amp Tubes", caption: "4x 6L6" },
    { label: "Power Amp Class", caption: "Class A/B" },
    { label: "Rectifier Type", caption: "Silicon Diodes" },
    { label: "Channel Configuration", caption: "Single Channel" },
    { label: "Special Features", caption: "Overkill, Mid Scoop" },
  ]
};

const iconaDesignStory = {
  heroKicker: "Icona Design Story",
  heroTitle: "Classic, Iconic, a Gearhead's Paradise.",
  heroBody:
    "Designed to deliver that iconic British sound we all know and love, spiced up with some exciting extras. ",
  sections: [
    {
      title: "Our Take On A Modern Classic",
      body:
        <>The <b><i>Icona</i></b> is designed to bring you that classic British sound with a whole bunch of extra goodies. From a simple bright switch to tweak the gain knob to a complete redesign of the preamp with <i>Overkill</i>, the <i><b>Icona</b></i> has enough bells and whistles for hours of tone building fun.</>,
      image: iconaKnobs,
      alt: "Close-up of the Hammerfaust gain and EQ section",
      align: "left",
      audioSrc: iconaMain,
      audioLabel: "Icona - Diabolical Majesty (Revocation)",
    },
    {
      title: "Like It? Clip It.",
      body:
        <>How can you have a heavily modified amplifier without some old school clipping? The Icona offers two different types of clipping: <i>zener</i> and <i>transistor</i>. The <i>zener</i> clipper is very aggressive and adds a lot of saturation, while the <i>transistor</i> clipper is much more subtle and subdued.</>,
      image: iconaClipper,
      alt: "Icona Clipper Switch",
      align: "right",
      audios: [
        { src: iconaClipperNone, label: "No Clipping — Rhythm demo" },
        { src: iconaClipperZener, label: "Zener Clipping — Rhythm demo" },
        { src: iconaClipperTransistor, label: "Transistor Clipping — Rhythm demo" },
      ]
    },
    {
      title: "Overkill: Hotter Than Hell ",
      image: iconaOverkill,
      body:
        <>Overkill brings the <b><i>Icona</i></b> from <i>Classic Rock</i> to <i>Death Metal</i> in an instant. This mode completely restructures the preamp and adds tons of extra gain to each of the gainstages, resulting in a rich and full sounding tone that keeps the amp's classic character.</>,
      alt: "Icona frontpanel showing the Overkill control",
      align: "left",
      audios: [
        { src: iconaOverkillOff, label: "Overkill Off — Rhythm demo" },
        { src: iconaOverkillOn, label: "Overkill On — Rhythm demo" },
      ]
    },

    {
      title: "Choose Your Voice",
      image: iconaVoice,
      body:
        <>The <i>Voice</i> Switch lets you select the overall voicing of the <b><i>Icona</i></b>. <i>Neutral</i> is the most vanilla setting and is a good baseline to start with. <i>Deep</i> shifts the tonestack, so it works better with low tuned guitars. <i>Modern</i> mode throws all rules out of the window and bypasses the depth control to give you enormous lows and intense highs while scooping the mids.</>,
      alt: "Icona frontpanel showing the Voice control",
      align: "right",
      audios: [
        { src: iconaVoiceNeutral, label: "Neutral Voicing — Neutral Settings, Boosted" },
        { src: iconaVoiceDeep, label: "Deep Voicing — Neutral Settings, Boosted" },
        { src: iconaVoiceModern, label: "Modern Voicing — Neutral Settings, Boosted" },
      ]
    },


  ],
  principles: [
    "ToneSuite - Dave Davidson",
    "Classic Gain",
    "Heavily Modded",
    "Bright & Tight"
  ],

  features: [
    { label: "Preamp Tubes", caption: "3x 12AX7" },
    { label: "Power Amp Tubes", caption: "2x KT88" },
    { label: "Power Amp Class", caption: "Class A/B" },
    { label: "Rectifier Type", caption: "Silicon Diodes" },
    { label: "Channel Configuration", caption: "Single Channel, Multiple Modes" },
    { label: "Special Features", caption: "Overkill, Bright Switch,  2 Clipping Modes, 3 Unique Voicings" },
  ]
};

const nassauDesignStory = {
  heroKicker: "Nassau Design Story",
  heroTitle: "Vintage, Pristine Cleans",
  heroBody:
    "Designed to deliver anything from Jazzy cleans to smooth Bluesy leads, the Nassau brings that familiar vintage amp feel.",
  sections: [
    {
      title: "From Clean to Drive",
      body:
        <>The <b><i>Nassau</i></b> is designed to deliver vintage American cleans with the possibility to be driven into a smooth overdrive sound for tasteful leads. The built-in tube driven tremolo circuit provides an extra layer for your tone to explore.</>,
      image: nassauKnobs,
      alt: "Close-up of the Nassau gain and EQ section",
      align: "left",
      audioSrc: nassauMain,
      audioLabel: "Nassau - Galleries of Morbid Artistry (Revocation)",
    },
    {
      title: "Bright, Era and Deep.",
      body:
        <>The <b><i>Nassau</i></b> comes with three mode switches. The <i>Bright</i> control introduces more highs into the preamp, while the <i>Deep</i> control adds more lows and subs. The <i>Era</i> control changes the overall gain characteristics of the amplifier.</>,
      image: nassauSwitches,
      alt: "Nassau Brigh Era and Deep controls",
      align: "right",
      audios: [
        { src: nassauNeutral, label: "Neutral Settings — Rhythm demo" },
        { src: nassauBright, label: "Bright On — Rhythm demo" },
        { src: nassauEra, label: "Era On — Rhythm demo" },
        { src: nassauDeep, label: "Deep On — Rhythm demo" },
      ]
    },
    {
      title: "Tube Tremolo ",
      image: nassauTremolo,
      body:
        <>The <b><i>Nassau</i></b> also incorporates an integrated, tube driven <i>Tremolo</i> circuit. You can control the <i>Speed</i> and <i>Intensity</i> to set the effect exactly to your liking and add another dimension to your sound. </>,
      alt: "Nassau frontpanel showing the Tremolo controls",
      align: "left",
      audios: [
        { src: nassauTremoloOff, label: "Tremolo Off - Clean Demo" },
        { src: nassauTremoloMild, label: "Mild Tremolo - Clean Demo" },
        { src: nassauTremoloIntense, label: "Intense Tremolo - Clean Demo" },
      ]
    },


  ],
  principles: [
    "ToneSuite - Dave Davidson",
    "Vintage Clean",
    "Tube Tremolo",
    "Smooth Overdrive"
  ],

  features: [
    { label: "Preamp Tubes", caption: "2x 12AX7 + 1x 12AX7 for Tremolo" },
    { label: "Power Amp Tubes", caption: "2x 6V6" },
    { label: "Power Amp Class", caption: "Class A/B" },
    { label: "Rectifier Type", caption: "Tube Rectifier" },
    { label: "Channel Configuration", caption: "Single Channel, Multiple Gain Settings" },
    { label: "Special Features", caption: "Tube Based Tremolo, Era Gain Switch, Deep and Bright controls." },
  ]
};


const Paragraph = ({ title, children, smallTitle }) => {
  return <Box sx={{ mt: 2, textAlign: "left" }}>

    <Typography sx={{ fontSize: { md: "23px", xs: "16px" } }} variant="body2" ><b>{title}:</b> {children}</Typography>
  </Box>
}

const AmplifierBanner = () => {
  return (
    <>
      <FullPagePage sx={{ background: "radial-gradient(circle, #5689d6ff 0%, #296fd8ff 100%)" }}>
        <Box sx={{ p: 5, pl: 0, pr: 0, background: "radial-gradient(circle, #eee 0%,#aaa 100%)", justifyContent: "center", alignItems: "center", color: TEXT_COLOR }} >

          <Box sx={{ width: "100%", justifyContent: "center" }}>
            <Typography variant="h3" sx={{ textAlign: "center", mb: 3 }}>The Amplifier Collection</Typography>

          </Box>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12} md={6} lg={4} sx={{ color: TEXT_COLOR }}>
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                <b>ToneSuite - Dave Davidson</b>contains a collection of 4 custom amplifiers. From warm jazz clean tones to ripping metal rhythms and soaring leads, everything is covered.
              </Typography>
            </Grid>
          </Grid>
        </Box >
      </FullPagePage>

      <FullPagePage sx={{ background: "radial-gradient(circle, #5689d6ff 0%, #296fd8ff 100%)" }}>
        <ImageTextSection
          image={cobaltBackground}
          title="The Cobalt"
          headerImage={cobaltPlugin}
          align="right"
          imageEnterFrom="left"
          description="An absolute workhorse of an amplifier. It can handle the most heavy riffs you throw at it, without hesitation."
          ctaLabel="Explore this Amp"
          storyRootSx={{ background: "none" }}
          designStory={cobaltDesignStory}
        />
      </FullPagePage>

      <FullPagePage sx={{ background: "radial-gradient(circle, #2c2727ff 0%, #121111ff 100%)" }}>
        <ImageTextSection
          image={hammerfaustBackground}
          headerImage={hammerfaustPlugin}
          align="left"
          imageEnterFrom="right"
          title="The Hammerfaust"
          description="Built for precision and power, this amp delivers a dark, aggressive tone with surgical clarity."
          ctaLabel="Explore this Amp"
          designStory={hammerfaustDesignStory}

        />
      </FullPagePage>

      <FullPagePage sx={{ background: "radial-gradient(circle, #f23f3fff 0%,#cd3939ff 100%)" }}>
        <ImageTextSection
          image={iconaBackground}
          headerImage={iconaPlugin}
          align="right"
          title="The Icona"
          description="Vintage attitude. Modern firepower."
          ctaLabel="Explore this Amp"
          designStory={iconaDesignStory}
        />
      </FullPagePage>
      <FullPagePage sx={{ background: "radial-gradient(circle, #ffb814ff 0%, #cda139ff 100%)" }}>
        <ImageTextSection
          image={nassauBackground}
          headerImage={nassauPlugin}
          align="left"
          imageEnterFrom="right"
          title="The Nassau"
          description="From crystal-clear cleans to lush, tube overdrive, The Nassau proves that clean doesn't mean tame."
          ctaLabel="Explore this Amp"
          designStory={nassauDesignStory}
        />
      </FullPagePage>


    </>
  )
}

export default AmplifierBanner;
